<div>
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
    <div class="tw:w-auto tw:px-[15px]">
      <div class="kvp__k tw:py-1">Date:</div>
      <div class="kvp__k tw:py-1">Event:</div>
      <div class="kvp__k tw:py-1">Added by:</div>
    </div>
    <div class="tw:flex-1 tw:px-[15px]">
      <div class="kvp__v tw:py-1">{{ timelineSection.sectionDate | date: 'dd MMM yyyy' }} &nbsp;</div>
      <div class="kvp__v tw:py-1">{{ timelineSection.eventDescription }} &nbsp;</div>
      <div class="kvp__v tw:py-1">{{ timelineSection.createdByName || 'Unknown' }} &nbsp;</div>
    </div>
  </div>

  @if (canDelete()) {
    <div class="tw:flex tw:justify-end">
      <button mat-button color="warn" (click)="confirmDelete()">Delete</button>
    </div>
  }
</div>
